/**
 * Get the response errors
 * @param {*} response
 */
export function getResponseErrors(response) {
  let validationErrors = [];
  let strValidationErrors = "";

  const data = response.response?.data?.data;
  const message = response.response?.data?.message || "Something went wrong";

  if (typeof data === "object") {
    strValidationErrors = Object.keys(data)
      .map((key) => {
        const arrErrors = data[key];
        if (Array.isArray(arrErrors)) {
          validationErrors = [...validationErrors, ...arrErrors];
          return arrErrors.map((error) => error).join(", ");
        }
        return null;
      })
      .filter((item) => item)
      .join(" ");
  }

  return {
    message,
    validationErrors,
    strValidationErrors,
  };
}

/**
 * Get a message that is safe to show the user for a failed request.
 * A 5xx answers with the raw server exception in `message`, and a request that
 * never got a response has none at all, so both fall back to the caller's own
 * text. Only the message of a client error (4xx) is written for the user.
 * @param {*} response axios error
 * @param {String} fallbackMessage already translated text to show instead
 */
export function getUserErrorMessage(response, fallbackMessage) {
  const status = response?.response?.status;
  const message = response?.response?.data?.message;

  if (!status || status >= 500 || !message) {
    return fallbackMessage;
  }

  return message;
}

